function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "informacoes",
  transform: "translate(-331.49 -635.547)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  transform: "translate(331.99 636.047)",
  fill: "none",
  stroke: "#565656",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.2,651.683a2.983,2.983,0,0,1,.088-.579q.051-.227.154-.6l.9-3.37c.009-.039.017-.078.022-.117a.488.488,0,0,0,.014-.11c0-.2-.063-.324-.19-.373a2.5,2.5,0,0,0-.7-.095v-.4q.424-.029,1.23-.117t1.15-.161l.645-.125-1.165,4.27q-.146.549-.2.762a3.981,3.981,0,0,0-.132.7.248.248,0,0,0,.073.213.311.311,0,0,0,.161.043q.227,0,.564-.388a5.735,5.735,0,0,0,.593-.813l.33.213a10.216,10.216,0,0,1-1.121,1.45,1.94,1.94,0,0,1-1.362.615,1.2,1.2,0,0,1-.74-.249A.931.931,0,0,1,341.2,651.683Zm2.9-9.39a1,1,0,0,1,1,1,.991.991,0,0,1-.293.717.964.964,0,0,1-.711.293,1,1,0,0,1-1.01-1.01.964.964,0,0,1,.293-.711A.991.991,0,0,1,344.1,642.293Z",
  fill: "#565656"
}));

function SvgInformacoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacoes);
export default __webpack_public_path__ + "static/media/informacoes.27bbf2f7.svg";
export { ForwardRef as ReactComponent };